import axios from 'axios';

const API = axios.create({
  baseURL: 'https://vida.ntssoftweb.com/api',
  timeout: 30000,
  maxContentLength: Infinity,
  maxBodyLength: Infinity
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // حذف هدرهای اضافی
  delete config.headers['Content-Length'];
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;